import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { Ornament } from './Ornament';
export function Urgency() {
  return <section className="py-8 px-5 bg-radial-glow" data-id="element-300">
      <div className="max-w-lg mx-auto text-center" data-id="element-301">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-302">
          <div className="flex justify-center mb-3 text-gold-500/50" data-id="element-303">
            <Clock size={26} strokeWidth={1} data-id="element-304" />
          </div>

          <h2 className="text-gold-400 text-xs tracking-[0.2em] uppercase mb-4" data-id="element-305">
            Una palabra sobre el tiempo
          </h2>

          <div className="space-y-2.5 text-[14px] sm:text-[15px] text-cream-200 font-light leading-relaxed" data-id="element-306">
            <p data-id="element-307">Ester tuvo UN momento. Y cuando llegó, tuvo que estar lista.</p>
            <p data-id="element-308">
              No porque fuera perfecta. Sino porque había pasado por el proceso.
            </p>
            <p className="font-medium text-cream-100 pt-1" data-id="element-309">
              Hoy, mientras lees esto... tu momento también se está acercando.
            </p>
            <p className="font-serif text-lg sm:text-xl text-gold-400 italic pt-2" data-id="element-310">
              La pregunta no es si llegará. La pregunta es: ¿estarás posicionada
              cuando llegue?
            </p>
          </div>

          <Ornament className="mt-6" data-id="element-311" />
        </motion.div>
      </div>
    </section>;
}